import { N900 } from '@atlaskit/theme/colors';
import { FormattedPriceCalculationResponse } from '@atlassiansox/bxp-use-pricing';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from './center-justified-container';
import { PriceDisplay } from './price-display';

export type MonthlyProps = {
  readonly priceCalc: FormattedPriceCalculationResponse;
  readonly fontSize: string;
  readonly planName: string;
};

export const Monthly = ({ priceCalc, fontSize, planName }: MonthlyProps) => {
  const { formattedTotalPrice, formattedAvgPerUnitPrice } = priceCalc;

  return (
    <>
      <PriceDisplay
        formattedPrice={formattedAvgPerUnitPrice}
        fontSize={fontSize}
        planName={planName}
      />
      <CenterJustifiedContainer>
        <PriceDescLine1>
          <FormattedMessage
            id="pricingDescMessageMonthly1"
            defaultMessage="per user (estimated)"
            description="Montlhy pricing description line 1"
          />
        </PriceDescLine1>
        <PriceDescLine2>
          <FormattedMessage
            id="pricingDescMessageMonthly2"
            defaultMessage="{formattedTotalPrice} per month"
            description="Montlhy pricing description line 2"
            values={{ formattedTotalPrice }}
          />
        </PriceDescLine2>
      </CenterJustifiedContainer>
    </>
  );
};

const PriceDescLine1 = styled.div`
  font-size: 16px;
  line-height: 24px;
`;

const PriceDescLine2 = styled.div`
  color: ${N900};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 32px;
`;
